/* global Fupcah */

import trackingOperator from './Tracking/TrackingOperator';
import trackingViewsImpressionsHandler from './Tracking/TrackingViewsImpressionsHandler';
import trackingDataHandler from './Tracking/TrackingDataHandler';

/**
 * Initialise Tracking
 *
 * Tracking can only be initialised, when both the document, and
 * fupcah have loaded.
 */
document.addEventListener('DOMContentLoaded', function () {
	function bindTracking() {
		trackingOperator.storePreviousPageAsTrackingDetail();
		trackingViewsImpressionsHandler.checkReloadState();
		trackingViewsImpressionsHandler.collect();
		trackingOperator.updateHrefsOfReferralLinks();

		// Catch all click events for internal links
		document.addEventListener('mouseup', function (event) {
			if (event.rightClick === false) {
				const target = event.target;
				if (target && target.classList.contains('TrackingInternalLink')) {
					const fact = trackingOperator.constructFactDetailsForViewsAndImpressions(target);
					trackingViewsImpressionsHandler.send([fact]);
				}
			}
		});
	}

	Fupcah.onload(() => {
		bindTracking();
	});
	document.addEventListener('wishlist_loaded', () => {
		bindTracking();
	});
	document.addEventListener('premium_click_tracker_update_listeners', () => {
		bindTracking();
	});
});

/**
 * Write the current page url to the cookie just before leaving the page
 */
window.onbeforeunload = function () {
	const url = window.location.toString();
	const data = trackingDataHandler.retrieveTrackingDetails();

	if (data !== null) {
		data.previousPage = url;
		trackingDataHandler.storeTrackingDetails(data);
	}
};
